import type { ReceiptOrder } from '@delivery/shared';
import type { OrderRow } from './types';

/**
 * 订单 → 小票数据。
 *
 * ★ **只此一份**。原来列表页和详情页各拼了一段一模一样的对象字面量,
 *   而「一模一样」只维持到下一次加字段:两边各漏过一个 ——
 *   收件备注漏在列表那边(单子打出来没有备注,而人明明写了),
 *   常驻备注两边都漏(它从来没上过票)。
 *   加字段时会改到的地方越多,漏掉的概率就越接近一。
 *
 * ★ 参数收 `OrderRow` 而不是详情类型:`OrderDetail extends OrderRow`,
 *   所以两边都传得进来,而这个函数只碰它们共有的那些字段。
 */
export function toReceipt(o: OrderRow): ReceiptOrder {
  return {
    orderNo: o.orderNo,
    receiverName: o.receiverName,
    receiverPhone: o.receiverPhone,
    receiverAddress: o.receiverAddress,
    packageCount: o.packageCount,
    codAmount: Number(o.codAmount ?? 0),
    codPending: o.codPending ?? false,
    /*
     * ★ 三种备注都带上 —— 少带一个,那种单打出来就是一张没有备注的票,
     *   而人明明在界面上写了。
     *
     * ★ 收件备注里可能有两句(收件人身上那句长期成立的交代在建单时
     *   并了进来),小票那边会按换行拆成两行印。
     *
     * ★ **不带**司机自己加的那条(driverNote)。
     *   用户原话:「小票不打印司机的备注」—— 而且这张纸是发车前
     *   打好贴在框上的,那会儿司机还没碰过这一单。
     */
    receiverNote: o.receiverNote ?? null,
    itemDescription: o.itemDescription ?? null,
    remark: o.remark ?? null,
    /* 商家的打印别名 —— 那家没配就是空,票上不会多一行 */
    shopAlias: o.customer?.printAlias ?? null,
    /* 商家的二维码 —— 同上,没配就一个点都不印 */
    shopQr: o.customer?.receiptQr ?? null,
    currency: o.currency,
    specialItems: o.specialItems ?? [],
    driverName: o.driver?.name ?? null,
    zoneName: o.zone?.name ?? null,
  };
}
